<template>
  <button
    :class="getClass"
    type="button"
    :disabled="disabled"
    :aria-label="$attrs.title || icone"
    @click="handleClick($event)">
    <b-icon :icon="icone" class="bIcone"></b-icon>
  </button>
</template>
<script>
export default {
  name: "ico-btn",
  props: {
    disabled: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    icone: {
      type: String,
      default: () => {
        return '';
      },
    },
    size: {
      type: String,
      default: () => {
        return '';
      },
    },
    type: {
      type: String,
      default: () => {
        return '';
      },
    },
    custom: {
      type: String,
      default: () => {
        return '';
      },
    },
    cb: {
      type: Function,
      default: () => {
        return ()=>{};
      },
    },
  },
  computed: {
    getClass() {
      const init = 'btnIco';
      const size = (this.size && this.size == 'p') ? 'litle ':'big ';
      const st = size+init;
      if(this.disabled) {
        return 'btnIcoDisabled';
      }
      switch(this.type) {
        case 'simple':
        return st+' simpleBtn';
        case 'warning':
        return st+' warningBtn';
        case 'toggleOn':
        return st+' toggleOn '+this.custom;
        case 'toggleOff':
        return st+' toggleOff';
        default:
        return st+' simpleBtn';
      }
    },
  },
  methods: {
    handleClick(evt) {
      if (this.disabled) return;
      if(this.cb) {
        this.cb()
        return;
      }
      this.$emit("click", evt);
    }
  }
};
</script>
<style>
.litle .bIcone {
  width: 14px;
  height: 14px;
  margin-top: 0;
}
.big .bIcone {
  width: 16px;
  height: 16px;
  margin-top: 0;
}
.litle {
  width: 28px;
  height: 28px;
}
.big {
  width: 32px;
  height: 32px;
}
.btnIco {
  border-radius: 50%;
  border: 0;
  padding: 0;
  margin-right: 2px;
  text-align: center;
  background-color: #525f7f;
  color: #FFF;
  float: right;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}
.btnIco:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(31, 42, 68, 0.22);
}
.btnIcoDisabled {
  border-radius: 50%;
  border: 0;
  width: 32px;
  height: 32px;
  margin-left: 2px;
  text-align: center;
  background-color: #393d49;
  color: #6a6e7a;
  float: right;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.simpleBtn {
  background-color: #525f7f;
  cursor: pointer;
}
.simpleBtn:hover {
  background-color: #6c7895;
}
.warningBtn {
  background-color: red;
  cursor: pointer;
}
.warningBtn:hover {
  background-color: #f36666;
}
.toggleOff {
  background-color: #000;
  cursor: pointer;
}
.toggleOff:hover {
  background-color: rgb(27, 25, 25);
}
.toggleOn {
  background-color: rgb(90, 110, 1);
  cursor: pointer;
}
.toggleOn:hover {
  background-color: rgb(0, 0, 0);
}
.orange {
  background-color: rgb(251, 130, 0);
}
.purple {
  background-color: rgb(155, 0, 251);
}
.pink {
  background-color: rgb(251, 0, 201);
}
.green {
  background-color: rgb(84 89 5);
}
</style>
